import { TimeSpan } from './time-span';
export class DateTime {
    constructor(year, month = 1, day = 1) {
        this.native = year instanceof Date
            ? year
            : new Date(year, month - 1, day);
    }
    static get now() { return new DateTime(new Date()); }
    static get today() {
        const now = this.now;
        return new DateTime(now.year, now.month, now.day);
    }
    get weekDay() {
        return this.native.getDay();
    }
    get totalDaysInMonth() {
        return new Date(this.native.getFullYear(), this.native.getMonth() + 1, 0).getDate();
    }
    get remainingDays() {
        return this.totalDaysInMonth - this.native.getDate();
    }
    get week() {
        const date = new Date(this.native.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        const week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
            - 3 + (week1.getDay() + 6) % 7) / 7);
    }
    get day() { return this.native.getDate(); }
    get month() { return this.native.getMonth() + 1; }
    get year() { return this.native.getFullYear(); }
    get ticks() { return this.native.getTime(); }
    get date() { return new DateTime(this.year, this.month, this.day); }
    subtract(date) {
        const ticks = this.ticks - date.ticks;
        return new TimeSpan(ticks);
    }
    add(date) {
        const time = this.native.getTime() + date.native.getTime();
        return new DateTime(new Date(time));
    }
    addDays(days) {
        const result = new Date(this.native);
        result.setDate(result.getDate() + days);
        return new DateTime(result);
    }
    addMonths(months) {
        const d = new Date(this.native.getTime());
        const days = d.getDate();
        d.setDate(1);
        d.setMonth(d.getMonth() + months);
        d.setDate(Math.min(days, new DateTime(d).totalDaysInMonth));
        return new DateTime(d);
    }
    static parseOrDefault(date) {
        if (date instanceof Date) {
            return new DateTime(date);
        }
        else if (date) {
            // parse: dd.MM.yyyy or dd/MM/yyyy
            const match = (/(\d+)\.(\d+)\.(\d+)/.exec(date) || // de-DE
                /(\d+)\/(\d+)\/(\d+)/.exec(date) // it-IT and en-GB
            );
            let time = match
                ? new Date(+match[3], +match[2] - 1, +match[1]).getTime() // keep the correct timezone
                : Date.parse(date); // parse: MM/dd/yyyy, etc.. - may end up with invalid timezone!
            if (isNaN(time)) {
                time = Date.parse(date); // fallback - may end up with invalid timezone!
            }
            if (time > 0) {
                return new DateTime(new Date(time));
            }
        }
        return null;
    }
    toISOString() {
        /*
         * The default implementation always converts local time to UTC and then create the iso format
         * this way all timezone informations get lost and it is imposible for a server to understand
         * what local time the user selected!
         * eg: 2022-04-21T22:00:00.000Z - the date got changed to yesterday! (-2h)
         */
        // return this.native.toISOString();
        /*
         * This custom implementation creates the iso format with local dates and
         * adds the correct timezone offset, so a server knows what the user selected
         * and which timezone he lifes in.
         * eg: 2022-04-22T00:00:00+02:00
         */
        const date = this.native;
        var tzo = -date.getTimezoneOffset(), dif = tzo >= 0 ? '+' : '-', pad = function (num) {
            return (num < 10 ? '0' : '') + num;
        };
        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    }
    toString() {
        return `${this.year}-${`${this.month}`.padStart(2, '0')}-${`${this.day}`.padStart(2, '0')}`;
    }
}
export var WeekDay;
(function (WeekDay) {
    WeekDay[WeekDay["Sunday"] = 0] = "Sunday";
    WeekDay[WeekDay["Monday"] = 1] = "Monday";
    WeekDay[WeekDay["Tuesday"] = 2] = "Tuesday";
    WeekDay[WeekDay["Wednesday"] = 3] = "Wednesday";
    WeekDay[WeekDay["Thursday"] = 4] = "Thursday";
    WeekDay[WeekDay["Friday"] = 5] = "Friday";
    WeekDay[WeekDay["Saturday"] = 6] = "Saturday";
})(WeekDay || (WeekDay = {}));
export var Month;
(function (Month) {
    Month[Month["January"] = 1] = "January";
    Month[Month["February"] = 2] = "February";
    Month[Month["March"] = 3] = "March";
    Month[Month["April"] = 4] = "April";
    Month[Month["May"] = 5] = "May";
    Month[Month["June"] = 6] = "June";
    Month[Month["July"] = 7] = "July";
    Month[Month["August"] = 8] = "August";
    Month[Month["September"] = 9] = "September";
    Month[Month["October"] = 10] = "October";
    Month[Month["November"] = 11] = "November";
    Month[Month["December"] = 12] = "December";
})(Month || (Month = {}));
